import { Controller, useFormContext } from "react-hook-form";
import { InputBaseParams } from "../Form";

/**
 * A controlled multi-line text
 * area input
 */
const TextArea = ({
  name,
  placeholder,
  rows = 1,
  rules,
  className,
  errorClassName
}: InputBaseParams & {
  rows?: number;
  placeholder?: string;
  className?: string;
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <textarea
          rows={rows}
          placeholder={placeholder}
          className={`${className} ${error && errorClassName}`}
          {...field}
        />
      )}
    />
  );
};

export default TextArea;
